import { priceSpecs } from '@scalefast/core';

export class CrossedPriceManager {
  private priceInfo: priceSpecs | undefined;
  private bundleRecommendedPricesProducts: any | undefined;
  private bundleCrossedPriceIsRecommendedPrice: boolean = false;

  bundleOldPrice: number | undefined;
  finalCrossedPrice: number = 0;

  private setBundleRecommendedPrices() {
    const bundledProductsV4Api =
      this.bundleRecommendedPricesProducts?.v4ApiResponse?.specific?.bundle_info?.bundle_recommended_prices?.elements ??
      this.bundleRecommendedPricesProducts?.v4ApiResponse?.specific?.bundle_info?.elements?.elements;
    const bundledProductsStoreSearch =
      this.bundleRecommendedPricesProducts?.v4ApiResponse?.specific?.elements ??
      this.bundleRecommendedPricesProducts?.v4ApiResponse?.specific?.bundle_info?.elements?.elements;
    let bundleRecommendedPrices;
    if (bundledProductsV4Api) {
      bundleRecommendedPrices = bundledProductsV4Api.map((priceInfo: any) => {
        const quantity = priceInfo.quantity_in_bundle ?? 1;
        if (!priceInfo?.prices) {
          return;
        }
        const firstCurrencyInfo: any = Object.values(priceInfo.prices)[0];
        return firstCurrencyInfo?.prices?.[0]?.recommended_price * quantity;
      });
    }
    if (bundledProductsStoreSearch) {
      bundleRecommendedPrices = bundledProductsStoreSearch.map((element: any) => {
        const quantity = element.quantity_in_bundle ?? element.quantity ?? 1;
        if (!element.price_info?.currencies) {
          return;
        }
        const firstCurrencyInfo: any = Object.values(element.price_info.currencies)[0];
        if (firstCurrencyInfo.prices) {
          return firstCurrencyInfo?.prices[0]?.recommended_price * quantity;
        }
        return firstCurrencyInfo?.[0]?.recommended_price * quantity;
      });
    }
    return bundleRecommendedPrices;
  }

  /**
   * Calculates the cross-price of the bundle products based on the sum of the recommended prices of its elements.
   * For META PLP, element prices are not defined, so the recommended price is obtained from the current child.
   * Used for stores with the "bundleCrossedPriceIsRecommendedPrice" setting, such as "ES".
   */
  private calculateBundleCrossedPrice(): void {
    const bundleRecommendedPrices = this.setBundleRecommendedPrices();
    let recomendedPrice = bundleRecommendedPrices?.reduce((acc: number, price: string) => {
      return acc + (price ? parseFloat(price) : 0);
    }, 0);
    if (recomendedPrice === undefined) {
      recomendedPrice = Number(this.priceInfo?.recommendedPrice ?? 0);
    }
    this.bundleOldPrice = recomendedPrice;
  }

  private getBundleCrossedPrice() {
    if (this.bundleRecommendedPricesProducts == undefined) {
      return 0;
    }

    if (typeof this.bundleRecommendedPricesProducts.price == 'string') {
      return this.bundleRecommendedPricesProducts.crossedPrice != ''
        ? this.bundleRecommendedPricesProducts.price.crossedPrice
        : null;
    } else {
      return this.bundleRecommendedPricesProducts.price.prices[0].crossed_price;
    }
  }

  setConfig(
    bundleRecommendedPricesProducts: any | undefined,
    bundleCrossedPriceIsRecommendedPrice: boolean,
    priceInfo: priceSpecs | undefined,
  ): void {
    this.bundleRecommendedPricesProducts = bundleRecommendedPricesProducts;
    this.bundleCrossedPriceIsRecommendedPrice = bundleCrossedPriceIsRecommendedPrice;
    this.priceInfo = priceInfo;
  }

  calculateCrossedPrice(): void {
    if (this.bundleCrossedPriceIsRecommendedPrice) {
      this.calculateBundleCrossedPrice();
    }

    if (this.bundleOldPrice === undefined || this.bundleOldPrice === 0) {
      if (this.priceInfo == null || this.priceInfo.oldPrice === 0) {
        this.finalCrossedPrice = this.getBundleCrossedPrice();
      } else {
        this.finalCrossedPrice = this.priceInfo.oldPrice ?? 0;
      }
    } else {
      this.finalCrossedPrice = this.bundleOldPrice;
    }
  }
}
